import React, { useState, useEffect, useRef } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { ReactComponent as ArrowDownIcon } from "../../../../assets/analytics/arrow-drop-down-svgrepo-com.svg";
import { ReactComponent as ArrowDownIconDark } from "../../../../assets/analytics/arrow-drop-down-svgrepo-com-dark.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/MainPage/addBlock/countDown/calendar.svg";
import { ReactComponent as CalendarIconDark } from "../../../../assets/MainPage/addBlock/countDown/calendarDark.svg";
import httpRequest from "../../../../axios/index";
import toast from "react-hot-toast";

import { useSelector } from "react-redux";

const CustomDurationSelector = ({
  setLoading,
  setAnalyticsData,
  setAnalyticsCount,
  analyticsdata,
  socialAccounts,
}) => {
  const { darkMode } = useSelector((state) => state.theme);

  const [startDateDisplay, setStartDateDisplay] = useState("");
  const [endDateDisplay, setEndDateDisplay] = useState("");

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDates, setSelectedDates] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const calendarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleApplyRange = async () => {
    setShowCalendar(false);
    // Set start date and end date for display
    const startDates = selectedDates[0].startDate.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    const endDates = selectedDates[0].endDate.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

    setStartDateDisplay(startDates);
    setEndDateDisplay(endDates);

    const startDate = selectedDates[0].startDate.toISOString();
    const endDate = selectedDates[0].endDate.toISOString();

    if ((!startDate && endDate) || (startDate && endDate.trim() === "")) {
      return;
    }
    try {
      setLoading(true);
      const { userid } = JSON.parse(localStorage.getItem("user")) || {};
      const resp = await httpRequest.get(
        `api/user/getanalytics/${userid}?startDate=${startDate}&endDate=${endDate}`
      );

      if (resp?.data?.data && resp?.data?.data?.length) {
        const platForms = resp.data?.data;
      
        let count = 0;
        platForms.forEach((element) => {
          count = count + element?.totalClicks || 0;
        });
        setAnalyticsCount(count);
        
        // Update platforms found in the response data
        const updatedSocialAccounts = socialAccounts.map((socialAccount) => {
          const foundPlatform = platForms.find((platform) => platform?.platform === socialAccount?.platform);
          if (foundPlatform && foundPlatform?.totalClicks) {
            return {
              ...socialAccount,
              clicks: foundPlatform?.totalClicks,
            };
          }
          return socialAccount;
        });
      
        setAnalyticsData(updatedSocialAccounts);
      } else {
        setAnalyticsCount(0);
        setAnalyticsData(socialAccounts);
      }
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const handleFilterChange = async (selectedOption) => {
    setShowCalendar(false); // Close calendar if it's open

    let durationParam;
    switch (selectedOption) {
      case "week":
        durationParam = "weekly";
        break;
      case "month":
        durationParam = "monthly";
        break;
      case "year":
        durationParam = "yearly";
        break;
      default:
        durationParam = "";
        break;
    }
    if (!durationParam || durationParam.trim() === "") {
      return;
    }
    try {
      setLoading(true);
      const { userid } = JSON.parse(localStorage.getItem("user")) || {};
      const resp = await httpRequest.get(
        `api/user/getanalytics/${userid}?duration=${durationParam}`
      );
      if (resp?.data?.data && resp?.data?.data?.length) {
        const platForms = resp.data?.data;
      
        let count = 0;
        platForms.forEach((element) => {
          count = count + element?.totalClicks || 0;
        });
        setAnalyticsCount(count);
        
        // Update platforms found in the response data
        const updatedSocialAccounts = socialAccounts.map((socialAccount) => {
          const foundPlatform = platForms.find((platform) => platform?.platform === socialAccount?.platform);
          if (foundPlatform && foundPlatform?.totalClicks) {
            return {
              ...socialAccount,
              clicks: foundPlatform?.totalClicks,
            };
          }
          return socialAccount;
        });
      
        setAnalyticsData(updatedSocialAccounts);
      } else {
        setAnalyticsCount(0);
        setAnalyticsData(socialAccounts);
      }
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  
  useEffect(() => {
    // Fetch data for the current week when the component mounts
    handleFilterChange("week");
  }, []); 

  return (
    <div className="relative w-[208px] h-[47px] mt-5" ref={calendarRef}>
      <select
        className="block appearance-none dark:text-color_v1_dark w-full bg-white dark:bg-dark-secondary rounded-md py-4 px-2 shadow-sm text-sm leading-5 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue focus:ring-blue-500 sm:text-sm sm:leading-5"
        defaultValue="week"
        onChange={(e) => {
          if (e.target.value === "custom") {
            setShowCalendar(true); // Open the calendar pop-up
          } else {
            setShowCalendar(false); // Close the calendar if any other option is selected
            setStartDateDisplay(""); // Clear start date display
            setEndDateDisplay(""); // Clear end date display
            handleFilterChange(e.target.value); // Fetch data based on selected option
          }
        }}
      >
        <option value="week" className="dark:text-color_v1_dark">
          Week
        </option>
        <option value="month" className="dark:text-color_v1_dark">
          Month
        </option>
        <option value="year" className="dark:text-color_v1_dark">
          Year
        </option>
        <option value="custom" className="dark:text-color_v1_dark">
          Custom Duration
        </option>
      </select>

      <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        {darkMode ? (
          <ArrowDownIconDark className="h-8 w-8 fill-current" />
        ) : (
          <ArrowDownIcon className="h-8 w-8 fill-current" />
        )}
      </div>

      {showCalendar && (
        <div className="absolute top-0 ml-56 left-0 z-10 bg-white p-4 shadow-md rounded-md">
          <DateRangePicker
            ranges={selectedDates}
            onChange={(ranges) => setSelectedDates([ranges.selection])}
            rangeColors={["#FF5349"]}
          />
          <div className="items-center justify-end flex">
            <button
              className="bg-main_color  lg:mt-9 text-white rounded-full py-1.5 px-[22px] text-small3_b smm:text-small2_b sm:text-small1_bold sm:w-48 w-full"
              onClick={handleApplyRange}
            >
              Apply Range
            </button>
          </div>
        </div>
      )}

      {!showCalendar && startDateDisplay && endDateDisplay && (
        <div
          className="absolute top-0 ml-56 left-0 z-10 bg-white  shadow-md rounded-md px-3 py-[15px] w-[295px] h-[50px] cursor-pointer dark:bg-dark-secondary dark:text-color_v1_dark"
          onClick={() => setShowCalendar(true)}
        >
          <div className="absolute inset-y-0 h-full flex items-center">
            {darkMode ? <CalendarIconDark /> : <CalendarIcon />}
          </div>
          <div className="pl-7">
            {startDateDisplay} - {endDateDisplay}
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            {darkMode ? (
              <ArrowDownIconDark className="h-8 w-8 fill-current" />
            ) : (
              <ArrowDownIcon className="h-8 w-8 fill-current" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDurationSelector;
